import { render, staticRenderFns } from "./gift-card-category.vue?vue&type=template&id=6bdcaf65&scoped=true&"
import script from "./gift-card-category.vue?vue&type=script&lang=js&"
export * from "./gift-card-category.vue?vue&type=script&lang=js&"
import style0 from "./gift-card-category.vue?vue&type=style&index=0&id=6bdcaf65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdcaf65",
  null
  
)

export default component.exports